import { render, staticRenderFns } from "./UserMessageSend.vue?vue&type=template&id=3275da3b&scoped=true"
import script from "./UserMessageSend.vue?vue&type=script&lang=js"
export * from "./UserMessageSend.vue?vue&type=script&lang=js"
import style0 from "./UserMessageSend.vue?vue&type=style&index=0&id=3275da3b&prod&lang=scss"
import style1 from "./UserMessageSend.vue?vue&type=style&index=1&id=3275da3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3275da3b",
  null
  
)

export default component.exports